import { forwardRef } from 'react';
import classes from './Search.module.scss';

function Search(props: SearchProps, ref: any) {
	const classNames = [classes.Search];
	if (props.className) {
		classNames.push(props.className);
	}

	function onChangeInput(e: any) {
		const text = e.target.value;
		if (e.which === 13) {
			if (props.onEnter) props.onEnter(text);
		}
	}

	return (
		<div className={classNames.join(' ')}>
			<SearchIcon />
			<input type="text" ref={ref} placeholder={props.placeholder || 'Keresés'} onKeyDown={onChangeInput} />
		</div>
	);
}

export default forwardRef(Search);

interface SearchProps {
	placeholder?: string;
	className?: string;
	onEnter?: Function;
}

function SearchIcon() {
	return (
		<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style={{ width: 20, height: 20, fill: '#ccc' }}>
			<path
				style={{ fill: '#ccc' }}
				d="m375.73 330.48a206.55 206.55 0 0 0 40.27-122.48c0-114.69-93.31-208-208-208s-208 93.31-208 208 93.31 208 208 208a206.62 206.62 0 0 0 122.49-40.27l136.26 136.27 45.25-45.25zm-167.73 21.52c-79.41 0-144-64.59-144-144s64.59-144 144-144 144 64.6 144 144-64.6 144-144 144z"
				fill="#fff"
			></path>
		</svg>
	);
}
